import {
  CropIcon,
  FaceIcon,
  InfoCircledIcon,
  MixerHorizontalIcon,
  MixIcon,
  TransparencyGridIcon,
  VideoIcon,
} from "@radix-ui/react-icons";

export const STUDIO_ACTIONS = [
  {
    id: "information",
    icon: InfoCircledIcon,
    labelKey: "studio.actions.information.label",
    tooltipKey: "studio.actions.information.tooltip",
  },
  {
    id: "background",
    icon: TransparencyGridIcon,
    labelKey: "studio.actions.background.label",
    tooltipKey: "studio.actions.background.tooltip",
  },
  {
    id: "crop-extend",
    icon: CropIcon,
    labelKey: "studio.actions.crop_extend.label",
    tooltipKey: "studio.actions.crop_extend.tooltip",
  },
  {
    id: "photo-effects",
    icon: MixerHorizontalIcon,
    labelKey: "studio.actions.photo_effects.label",
    tooltipKey: "studio.actions.photo_effects.tooltip",
  },
  {
    id: "edit-objects",
    icon: MixIcon,
    labelKey: "studio.actions.face_change.label",
    tooltipKey: "studio.actions.face_change.tooltip",
  },
  {
    id: "face",
    icon: FaceIcon,
    labelKey: "studio.actions.face.label",
    tooltipKey: "studio.actions.face.tooltip",
  },
  {
    id: "create-video",
    icon: VideoIcon,
    labelKey: "studio.actions.create_video.label",
    tooltipKey: "studio.actions.create_video.tooltip",
  },
] as const;
